<template>
	<div class="area">
		<h5 class="aviso" style="text-align: center;" >AVISO</h5>
		<table v-if="ultimoFolioNoImpreso" class="table" style="margin-bottom: 5px">
			<thead>
				<tr style="border: 1px solid #dee2e6">
					<th scope="col"  style="text-align: center;">AUN NO SE HA IMPRESO EL ULTIMO FOLIO REGISTRADO<br><br>
					 FOLIO :{{ultimoFolioNoImpreso}}</th>
				</tr>
			</thead>
		</table>
		<table v-if="foliosSinImprimir" class="table" >
			<thead>
				<tr style="border: 1px solid #dee2e6">
					<th scope="col" style="text-align: center;">FOLIOS PENDIENTES DE CANCELAR: <br><br> {{quitarFoliosDuplicados(foliosSinImprimir)}}</th>
				</tr>
			</thead>
		</table>
	</div>
</template>
<script type="text/javascript">
	import Vue from 'vue'
  	import comun from "@/../static/js/comun"
  	import api from '@/../static/js/api'
  	import axios from 'axios'
	
	export default{
    	data(){
      		return{
      			folios: null,
      		}
  		},
      	props:{
      		foliosSinImprimir : null,
      		ultimoFolioNoImpreso: null,
      	},
  		created(){
  			//console.log(this.quitarFoliosDuplicados(this.foliosSinImprimir))
  		},
  		methods:{
  			quitarFoliosDuplicados : function(foliosSinImprimir){
  				var foliosSinDuplicar = foliosSinImprimir.map((lista) => lista.Folio).filter((numero, index, array) => array.indexOf(numero) === index).join(", ").replace(/, ([^,]*)$/, ' Y $1')
  				
  				return foliosSinDuplicar
  			},
  		},
  	}


</script>
<style scoped>
	.aviso{
		background-color: white;
		color: black; 
		padding: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Caja/PendientesImprimir.vue